<template>
  <div>
    <NewROContainer />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import NewROContainer from "@/components/aberration/new/ro/NewROContainer.vue";

export default Vue.extend({
  components: {
    NewROContainer,
  },
});
</script>
